import React, { useEffect, useState } from "react";
import "./description.css";
import laptopMockup from "../../assets/imgs/mockups/laptop-mockup1.png";
import slide1 from "../../assets/imgs/previews/agent/base.jpg";
import slide2 from "../../assets/imgs/previews/agent/coastal.jpg";
import slide3 from "../../assets/imgs/previews/agent/futuristic.jpg";
import slide4 from "../../assets/imgs/previews/agent/luxury.jpg";
import slide5 from "../../assets/imgs/previews/agent/metropolitan.jpg"
import { motion, AnimatePresence } from "motion/react";
import img from "../../assets/imgs/IDX__2_-removebg-preview.png";

const slides = [slide1, slide2, slide3, slide4, slide5];

const Description = () => {
    const [index, setIndex] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => {
            setIndex((prev) => (prev + 1) % slides.length);
        }, 4000);

        return () => clearInterval(interval);
    }, []);

    return (
        <section className="site-description-container description-entrance">
            <div className="site-description">
                {/* <span className="site-description-badge site-description-title">Modern real estate web experiences</span>
            <h1 className="site-description-title">Apto Websites</h1> */}
                <div className="site-description-content">
                    <h1 className="site-description-title">Modern <span className="highlight">real estate</span> web experiences</h1>
                    <p className="site-description-text">
                        Grow your real estate business with a modern, mobile-friendly website. Apto Websites delivers beautiful, customizable designs, IDX integration,
                        and powerful marketing tools, all in one affordable package. Whether you’re an agent, team, or brokerage, we make it easy to stand out,
                        attract leads, and grow your brand online.
                    </p>
                    <div className="site-description-actions">
                        <a className="cta primary" href="/templates">View templates</a>
                        <a className="cta ghost" href="/pricing">See pricing</a>
                    </div>
                </div>
            </div>
            <div className="laptop-container">
                <div className="laptop-wrapper">
                    <img
                        src={laptopMockup}
                        className="laptop-image"
                        alt="Laptop mockup"
                    />

                    <div className="laptop-screen">
                        <AnimatePresence mode="wait">
                            <motion.img
                                key={index}
                                src={slides[index]}
                                className="slide"
                                initial={{ opacity: 0, scale: 1.05 }}
                                animate={{ opacity: 1, scale: 1 }}
                                exit={{ opacity: 0, scale: 0.98 }}
                                transition={{ duration: 0.8 }}
                            />
                        </AnimatePresence>
                    </div>
                </div>

            </div>
        </section>
    )
};

export default Description;
